import { appConstants } from '../helpers';

export const userService = {
	login,
	logout
};

function login(email, password) {
	const requestOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			email,
			password
		})
	};

	return fetch(`${appConstants.BASE_URL}auth/login`, requestOptions)
		.then(handleResponse)
		.then(user => {
			// store user details and jwt token in local storage to keep user logged in between page refreshes
			// localStorage.setItem('ea-user', JSON.stringify(user));
			return user;
		});
}

// remove user from local storage to log user out
function logout() {
	localStorage.removeItem('ed_token');
	localStorage.removeItem('ed_first_name');
	localStorage.removeItem('ed_last_name');
}

function handleResponse(response) {
	return response.text().then(text => {
		const data = text && JSON.parse(text);
		if (!response.ok) {
			if (response.status === 401) {
				// auto logout if 401 response returned from api
				logout();
				// location.reload(true);
			}
			const error = (data && data.messages && data.messages.error) || response.statusText;
			return Promise.reject(error);
		}
		return data;
	});
}